import React, { FormEvent } from 'react';
import { Col, Form, FormControlProps, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ACHPersonalNameFields from './ACHPersonalNameFields';
import ACHCorporateNameFields from './ACHCorporateNameField';
import { BankAccountInformation } from './MasterPaymentForm';

interface ACHFieldsProps {
  bankAccountInformation: BankAccountInformation;
  toggleAchType: () => void;
  handleInputChange: (e: any) => void;
  bankName: string | any;
}

class ACHFields extends React.Component<ACHFieldsProps> {
  render() {
    return (
      <div>
        <Row>
          <Col style={{ display: 'flex', justifyContent: 'center' }}>
            <h2>ACH Details</h2>
          </Col>
        </Row>
        <Row style={{ marginBottom: '15px' }}>
          <Col className='text-center'>
            <ToggleButtonGroup
              name='ach-type-toggle'
              type='radio'
              defaultValue={this.props.bankAccountInformation.accountType}
              onChange={this.props.toggleAchType}
              className="ios_tab"
            >

              <ToggleButton type='radio' value='PersonalChecking' id="pers">Personal</ToggleButton>
              <ToggleButton type='radio' value='CorporateChecking' id="corp">Corporate</ToggleButton>
            </ToggleButtonGroup>
          </Col>
        </Row>
        <Col lg={{ span: 8, offset: 2 }}>
          <Row>
            {this.props.bankAccountInformation.accountType === 'CorporateChecking' ?
              (
                <ACHCorporateNameFields
                  handleInputChange={this.props.handleInputChange}
                />
              ) :
              (
                <ACHPersonalNameFields
                  handleInputChange={this.props.handleInputChange}
                />
              )
            }
          </Row>
          <Row>
            <Col>
              <Form.Group style={{ display: 'flex', alignItems: 'center' }}>
                <FontAwesomeIcon
                  icon='university'
                  className='fa-lg'
                  style={{ marginRight: '12px' }}
                />
                <Form.Control
                  type='text'
                  inputMode='numeric'
                  pattern='[0-9]*'
                  autoComplete='off'
                  name='routingNumber'
                  placeholder='Routing Number'
                  required={true}
                  onChange={this.props.handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {this.props.bankName && (
            <div className="routing_bank_info">
              {this.props.bankName}
            </div>
          )}
          <Row>
            <Col>
              <Form.Group style={{ display: 'flex', alignItems: 'center' }}>
                <FontAwesomeIcon
                  icon='money-check-alt'
                  className='fa-lg'
                  style={{ marginRight: '12px', maxWidth: '21px' }}
                />
                <Form.Control
                  type='text'
                  inputMode='numeric'
                  pattern='[0-9]*'
                  autoComplete='off'
                  name='accountNumber'
                  placeholder='Account Number'
                  required={true}
                  onChange={this.props.handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group style={{ display: 'flex', alignItems: 'center' }}>
                <FontAwesomeIcon
                  icon='money-check-alt'
                  className='fa-lg'
                  style={{ marginRight: '12px', maxWidth: '21px' }}
                />
                <Form.Control
                  type='text'
                  inputMode='numeric'
                  pattern='[0-9]*'
                  autoComplete='off'
                  name='confirmAccountNumber'
                  placeholder='Confirm Account Number'
                  required={true}
                  onChange={this.props.handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </div>
    );
  }
}

export default ACHFields;
